const xtgl = [{
  path: 'xtgl_bmgl',
  name: 'xtgl_bmgl',
  component: () =>
            import('@/components/xtgl/bmgl'),
  meta: { title: '部门管理', requireAuth: true, keepAlive: true, permission: true }
},
{
  path: 'xtgl_gnpz',
  name: 'xtgl_gnpz',
  component: () =>
            import('@/components/xtgl/gnpz'),
  meta: { title: '功能配置', requireAuth: true, keepAlive: true, permission: true }
},{
  path: 'xtgl_g',
  name: 'xtgl_g',
  component: () =>
            import('@/components/xtgl/g'),
  meta: { title: '', requireAuth: true, keepAlive: true, permission: true }
},
{
  path: 'xtgl_gwgl',
  name: 'xtgl_gwgl',
  component: () =>
            import('@/components/xtgl/gwgl'),
  meta: { title: '岗位管理', requireAuth: true, keepAlive: true, permission: true }
},
{
  path: 'xtgl_yhgl',
  name: 'xtgl_yhgl',
  component: () =>
            import('@/components/xtgl/yhgl'),
  meta: { title: '用户管理', requireAuth: true, keepAlive: true, permission: true }
},
{
  path: 'xtgl_qxgl',
  name: 'xtgl_qxgl',
  component: () =>
            import('@/components/xtgl/qxgl'),
  meta: { title: '权限管理', requireAuth: true, keepAlive: true, permission: true }
},
{
  path: 'xtgl_cdgl',
  name: 'xtgl_cdgl',
  component: () =>
            import('@/components/xtgl/cdgl'),
  meta: { title: '菜单管理', requireAuth: true, keepAlive: true, permission: true }
},
{
  path: 'xtgl_gngl',
  name: 'xtgl_gngl',
  component: () =>
            import('@/components/xtgl/gngl'),
  meta: { title: '功能管理', requireAuth: true, keepAlive: true, permission: true }
},
{
  path: 'xtgl_rzgl',
  name: 'xtgl_rzgl',
  component: () =>
            import('@/components/xtgl/rzgl'),
  meta: { title: '日志管理', requireAuth: true, keepAlive: true, permission: true }
},
{
  path: 'xtgl_zdgl',
  name: 'xtgl_zdgl',
  component: () =>
            import('@/components/xtgl/zdgl'),
  meta: { title: '字典管理', requireAuth: true, keepAlive: true, permission: true }
},
{
  path: 'xtgl_sbtz',
  name: 'xtgl_sbtz',
  component: () =>
            import('@/components/xtgl/sbtz'),
  meta: { title: '设备台账', requireAuth: true, keepAlive: true, permission: true }
}
]
export default xtgl



// WEBPACK FOOTER //
// ./src/router/xtgl.js